import { AppRoutes } from '../../app.app-manager-routes';
import { EntityManagerInfo } from '../../models/entity-config';
import { cloneObject } from '../../utils/util';

// Censimento delle voci del modulo ana-club: solo dati, nessuna EMC (spec 2026-10-19 §5).
// Generato da tools/split-app-manager-routes.mjs; le EMC stanno nel data delle rotte e nelle EMC che aprono le modali.
export class AnaClubRoutes {
  static readonly AnaKennelClubList: EntityManagerInfo = {
    id: 'AnaKennelClubList',
    name: 'anakennelclub',
    translateSuffixs: ['generic.', 'anakennelclub.'],
    entityServices: [
      { name: 'anakennelclub', serviceName: 'restCommon' },
      { name: 'GetGeoNazioneList', serviceName: 'restCommon' },
      { name: 'anatiporelazionekennelclub', serviceName: 'restCommon' }
    ],
    url: 'anakennelclublist',
    parent: AppRoutes.AnaClub
  };

  static readonly AnaKennelClubEdit: EntityManagerInfo = cloneObject(AnaClubRoutes.AnaKennelClubList, {
    id: 'AnaKennelClubEdit',
    url: 'anakennelclubedit',
    parent: AnaClubRoutes.AnaKennelClubList
  });

  static readonly AnaKennelClubNew: EntityManagerInfo = cloneObject(AnaClubRoutes.AnaKennelClubList, {
    id: 'AnaKennelClubNew',
    url: 'anakennelclubnew',
    parent: AnaClubRoutes.AnaKennelClubList
  });

  static readonly GenLwWalletRichiestaList: EntityManagerInfo = {
    id: 'GenLwWalletRichiestaList',
    name: 'genlwwalletrichiesta',
    translateSuffixs: ['generic.', 'genlwwalletrichiesta.'],
    url: 'genlwwalletrichiestalist',
    parent: AppRoutes.AnaClub
  };

  static readonly GenLwWalletRichiestaEdit: EntityManagerInfo = {
    id: 'GenLwWalletRichiestaEdit',
    name: 'genlwwalletrichiestaedit',
    translateSuffixs: ['generic.', 'genlwwalletrichiesta.'],
    url: 'genlwwalletrichiestaedit',
    parent: AnaClubRoutes.GenLwWalletRichiestaList
  };
}
